import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, DestroyRef, inject } from '@angular/core';
import { LoginService } from '../../../core/services/login.service';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { UtilsService } from '../../../core/services/utils';
import { OpenidOauthConfig } from '../../models/login/OpenidOauthConfig';
import { OpenidProviderComponent } from '../openid-provider/openid-provider.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'linkedin-signin',
    templateUrl: './linkedin-signin.component.html',
    styleUrls: ['./linkedin-signin.component.scss'],
    standalone: true
})

export class LinkedinSigninComponent extends OpenidProviderComponent implements AfterViewInit {
  private readonly linkedInUrl = '{issuer}?response_type=code&client_id={clientId}&redirect_uri={redirectUri}&state={state}&scope={scope}';
  private readonly linkedin = 'linkedin';
  @Input()
  private challenge: string;
  private redirectUrl: string;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(DOCUMENT) private document: any,
              private loginService: LoginService,
              private sessionStorage: SessionStorageService,
              private utils: UtilsService) {
    super();
    this.openIdSettingsErrorSubscriber = this.openIdSettingsSubscriber.bind(this);
    this.openIdSettingsSubscriber = this.openIdSettingsSubscriber.bind(this);
  }

  public ngAfterViewInit() {
    this.loginService.getOAuthSettings(this.challenge, this.linkedin)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.openIdSettingsSubscriber, this.openIdSettingsErrorSubscriber);
  }

  public linkedinSignIn() {
    this.sessionStorage.put('login_provider', this.linkedin);
    this.document.location.href = this.redirectUrl;
  }

  private openIdSettingsSubscriber(res: OpenidOauthConfig) {
    const {issuer, clientId, redirectUri, scope} = res;
    const hydraNonce = this.sessionStorage.value('nonce');
    const customParams = {'nonce': hydraNonce, 'challenge': this.challenge, 'provider': this.linkedin};
    const state = super.encodeCustomParams(customParams);
    const url = this.utils.parseTemplateString(this.linkedInUrl, {
      issuer, clientId, redirectUri, state, scope
    });
    this.redirectUrl = url;
  }

  private openIdSettingsErrorSubscriber(err) {
    const msg = super.getErrorMsg(err);
    console.error(msg);
  }
}
